// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-tab-alert-wrapper{height:100%;width:100%;text-align:left}.search-tab-alert-wrapper>.v-alert,.v-application .search-tab-alert-wrapper .info{border-radius:0!important;background-color:#e8f5f6!important;border-color:#e8f5f6!important;margin:0;padding-top:12px;padding-bottom:11px}.search-tab-alert-wrapper>.v-alert .v-icon{color:#a7d9dd!important;margin-top:12px;margin-right:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
